const ecommerceConfig = [
  {
    path: "/ecommerce/admin/clients",
    name: "ecommerce.admin.clients",
    component: () => import("@/modules/Ecommerce/views/ClientList.vue"),
    meta: {
      env: ["production"],
      pageTitle: "Clientes da Loja",
      roles: [1, 2, 5, 6],
    }
  },
  {
    path: "/ecommerce/settings",
    name: "ecommerce.settings",
    component: () => import("@/modules/Ecommerce/views/StoreSettingsPage.vue"),
    meta: {
      env: ["production"],
      pageTitle: "Configuraçães da loja",
      roles: [1, 2, 5, 6],
    }
  },
  {
    path: "/home-editor",
    name: "ecommerce.home-editor",
    component: () => import("@/modules/Ecommerce/views/HomePageEditor.vue"),
    meta: {
      roles: [5,1],
      layout: "full"
    }
  },
  {
    path: '/ecommerce/store/settings',
    name: 'ecommerce.settings.store.show',
    component: () => import('@/modules/Ecommerce/views/StoreSettings.vue'),
    meta: {
      roles: [1, 2, 5, 6],
    }
  },
  {
    path: "/ecommerce/onboarding",
    name: "ecommerce.onboarding",
    component: () => import("@/modules/Ecommerce/views/OnboardingPage.vue"),
    meta: {
      roles: [5],
      layout: "full",
      env: ["production"],
      pageTitle: "Onboarding da Loja"
    }
  },


];
export default ecommerceConfig;
